import React from 'react';
import { Button, Card, CardBody, Input, Table } from 'reactstrap';
import { AdditionalField } from './types';

interface AdditionalFieldsSectionProps {
    additionalFields: AdditionalField[];
    onAddField: () => void;
    onUpdateField: (id: string, field: 'name' | 'description', value: string) => void;
    onRemoveField: (id: string) => void;
}

const AdditionalFieldsSection: React.FC<AdditionalFieldsSectionProps> = ({
    additionalFields,
    onAddField,
    onUpdateField,
    onRemoveField
}) => {
    const handleInputChange = (id: string, field: 'name' | 'description') => (e: React.ChangeEvent<HTMLInputElement>) => {
        onUpdateField(id, field, e.target.value);
    };

    return (
        <Card className="shadow border-0 overflow-hidden rounded-3">
            <div className="bg-soft-primary p-3 border-bottom border-light d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0 text-primary fw-semibold d-flex align-items-center">
                    <i className="ri-file-list-3-line me-2 fs-18"></i>
                    Campos Adicionales
                </h5>
                <Button
                    color="primary"
                    size="sm"
                    className="btn-label shadow-sm"
                    onClick={onAddField}
                >
                    <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                    Añadir Campo
                </Button>
            </div>
            <CardBody className="p-0 bg-white">
                <div className="table-responsive">
                    <Table className="table-nowrap align-middle mb-0 table-hover">
                        <thead className="bg-light text-muted text-uppercase small">
                            <tr>
                                <th className="ps-4" style={{ width: '30%' }}>Nombre</th>
                                <th style={{ width: '50%' }}>Descripción</th>
                                <th style={{ width: '20%' }} className="text-end pe-4">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {additionalFields.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="text-center py-5">
                                        <h5 className="text-muted mb-1">No hay campos adicionales</h5>
                                        <p className="text-muted mb-0 small">Agregue información extra si es necesario</p>
                                    </td>
                                </tr>
                            ) : (
                                additionalFields.map((field, index) => (
                                    <tr key={field.id} className={index % 2 === 0 ? 'bg-white' : 'bg-soft-light bg-opacity-25'}>
                                        <td className="ps-4">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-text-spacing text-muted"></i>
                                                </span>
                                                <Input
                                                    bsSize="sm"
                                                    value={field.name}
                                                    onChange={handleInputChange(field.id, "name")}
                                                    placeholder="Nombre"
                                                    className="form-control border-start-0 ps-1"
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text bg-light border-end-0">
                                                    <i className="ri-file-list-2-line text-muted"></i>
                                                </span>
                                                <Input
                                                    bsSize="sm"
                                                    value={field.description}
                                                    onChange={handleInputChange(field.id, "description")}
                                                    placeholder="Descripción"
                                                    className="form-control border-start-0 ps-1"
                                                />
                                            </div>
                                        </td>
                                        <td className="text-end pe-4">
                                            <Button
                                                color="soft-danger"
                                                size="sm"
                                                className="btn-icon shadow-none"
                                                onClick={() => onRemoveField(field.id)}
                                                title="Eliminar campo"
                                            >
                                                <i className="ri-delete-bin-line"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </CardBody>
        </Card>
    );
};

export default AdditionalFieldsSection;
